import useStudySnapshotToggle from "hooks/useStudySnapshotToggle/useStudySnapshotToggle";

export default useStudySnapshotToggle;
